'use client';

import {Typography } from '@mui/material';
import { isEmpty } from 'lodash-es';
import React, { Fragment, useEffect } from 'react';
import PostType, { CampaignType } from '../../constants/postType.constants';
import useStore from '../../stores/store';
import PostContributorCard from './postContributorsCard';
import { authorizedServerFetch } from '@/actions/server.actions';
import Dialog from '@ui/Dialog';


function PostContributorsDialog() {
  const { open, type, post, hideDialog, postType } = useStore(
    (state) => state.postContributorDialog,
  );
  const [showDialog, setShowDialog] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [donors, setDonors] = React.useState([]);
  const [inkindDonors, setInkindDonors] = React.useState([]);
  const [volunteers, setVolunteers] = React.useState([]);
  const [tabType, setTabType] = React.useState(null);
  const [noContributionsFromUserOrg, setNoContributionsFromUserOrg] =
    React.useState(false);

  useEffect(() => {
    if (open && type === 'contributors') {
      setShowDialog(true);
      setTabType(postType);
    } else {
      setDonors([]);
      setVolunteers([]);
      setInkindDonors([]);
      setTabType(null);
      setShowDialog(false);
      setNoContributionsFromUserOrg(false);
    }
  }, [open, postType, type]);

  const handleClose = () => {
    setNoContributionsFromUserOrg(false);
    hideDialog();
  };

  useEffect(() => {
    const getPostContributors = async (id) => {
      setLoading(true);
      const { data } = await authorizedServerFetch(
        `/posts/${id}/contributions`,
      );
      console.log('getPostContributors', data);
      const responseData = data?.data;
      if (responseData) {
        if (
          isEmpty(responseData.donations) &&
          isEmpty(responseData.inKindDonations) &&
          isEmpty(responseData.volunteerings)
        ) {
          setTabType(postType);
          setDonors([]);
          setInkindDonors([]);
          setVolunteers([]);
          const hasContribution =
            post.sourcePostData.totalVolunteers ||
            post.totalDonations ||
            post.renderProps.donations.total ||
            post.latestInKindDonors.length;
          setNoContributionsFromUserOrg(hasContribution);
        } else {
          setTabType(postType);
          setDonors(responseData.donations);
          setInkindDonors(responseData.inKindDonations);
          setVolunteers(responseData.volunteerings);
          setNoContributionsFromUserOrg(false);
        }
      } else {
        setTabType(postType);
        setDonors([]);
        setInkindDonors([]);
        setVolunteers([]);
        setNoContributionsFromUserOrg(false);
      }
      setLoading(false);
    };
    if (showDialog && post) {
      getPostContributors(post.id);
    }
  }, [post, showDialog]);

  const getTitle = () => {
    switch (tabType) {
      case CampaignType.CollectGoods:
        return 'In-Kind Donations';
      case CampaignType.FundRaise:
        return 'Donations';
      case PostType.Volunteering:
        return 'Volunteering';
      case PostType.CrowdFunding:
        return 'Contributions';
      default:
        return 'Giving Activity';
    }
  };

  if (!showDialog) return null;

  return (
    <Dialog
      title={getTitle()}
      isOpen={showDialog}
      maxWidth="md"
      loading={loading}
      onClose={handleClose}>
      <>
        {noContributionsFromUserOrg ? (
          <div>
            <div className="flex w-full items-center justify-center">
              <Typography variant="body1">
                Thanks for checking! Although no members of your organization
                have contributed to this post yet, it has received support from
                members of other organizations.
              </Typography>
            </div>
          </div>
        ) : (
          <div className="flex w-full flex-col">
            {tabType === CampaignType.CollectGoods &&
              (inkindDonors.length ? (
                inkindDonors.map((userData) => (
                  <Fragment key={userData.createdAt}>
                    <PostContributorCard
                      contributor={userData}
                      key={userData.createdAt}
                      type={CampaignType.CollectGoods}
                    />
                    {/* <Divider variant="middle" /> */}
                  </Fragment>
                ))
              ) : (
                <div className="text-center">No In-Kind Donors found</div>
              ))}
            {tabType === CampaignType.FundRaise &&
              (donors.length ? (
                donors.map((userData) => (
                  <Fragment key={userData.createdAt}>
                    <PostContributorCard
                      contributor={userData}
                      key={userData.createdAt}
                      type={CampaignType.FundRaise}
                    />
                    {/* <Divider variant="middle" /> */}
                  </Fragment>
                ))
              ) : (
                <div className="text-center">No Donors found</div>
              ))}

            {tabType === PostType.Volunteering &&
              (volunteers.length ? (
                volunteers.map((userData) => (
                  <Fragment key={userData.createdAt}>
                    <PostContributorCard
                      contributor={userData}
                      key={userData.createdAt}
                      type={PostType.Volunteering}
                    />
                    {/* <Divider variant="middle" /> */}
                  </Fragment>
                ))
              ) : (
                <div className="text-center">No Volunteers found</div>
              ))}

            {tabType === PostType.CrowdFunding &&
              (donors.length ? (
                donors.map((userData) => (
                  <Fragment key={userData.createdAt}>
                    <PostContributorCard
                      contributor={userData}
                      key={userData.createdAt}
                      type={PostType.CrowdFunding}
                    />
                    {/* <Divider variant="middle" /> */}
                  </Fragment>
                ))
              ) : (
                <div className="text-center">No Contributors found</div>
              ))}
          </div>
        )}
      </>
    </Dialog>
  );
}

export default PostContributorsDialog;
